import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import type { IODataEntityDescriptor } from "../declarations/ODataExplorer";
import React from "react";

interface ISelectChipsProps {
    entity: IODataEntityDescriptor;
    onChange: (selection: string[]) => void;
    value: string[];
}

export default function SelectChips({
    entity,
    onChange,
    value,
}: ISelectChipsProps) {
    return (
        <Autocomplete
            multiple
            onChange={(_, v) => onChange(v)}
            options={entity.properties.map((p) => p.name)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="$select"
                    placeholder={value.length === 0 ? "All properties" : ""}
                />
            )}
            sx={{ minWidth: 480 }}
            value={value}
            size="small"
        />
    );
}
